var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2942 26.7064C22.47 35.8825 31.2358 37.8235 34.4708 38C36.5374 34.9712 37.4118 32.4709 38 30.2348C35.7649 28.0584 32.5114 25.8382 29.53 24.588L26 28.1172C24.7946 27.7942 21.485 26.4264 17.53 22.4705C13.5742 18.5137 12.2065 15.2057 11.8825 13.9994L15.4125 10.4702C14.1624 7.48875 11.9422 4.23431 9.76502 2C7.52989 2.58821 5.02963 3.46174 2 5.52924C2.17734 8.76526 4.11837 17.5295 13.2942 26.7064Z",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6133 14.0518C24.038 14.0518 26.0028 16.0174 26.0028 18.4414",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6133 9.66211C26.461 9.66211 30.3923 13.5934 30.3923 18.4413",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6133 5.27246C28.8858 5.27246 34.7818 11.1686 34.7818 18.4413",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon2);
export default __webpack_public_path__ + "static/media/contacts-icon2.8defbb333a4c0b14e2f06d979cd59b7f.svg";
export { ForwardRef as ReactComponent };